export default "__VITE_ASSET__B1ZRN3nD__"